const pageShortHand = {
  'cardmember-benefits': 'cb',
};

export const convertPage = (page) => pageShortHand[page] || page;
